import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { MatLegacyDialog as MatDialog, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { MatLegacyTableDataSource as MatTableDataSource } from '@angular/material/legacy-table';
import { Cutout } from 'cloud-shared-lib';
import * as _ from 'lodash';

import { SvgWorkspaceComponent } from '../../../../../components/svg-workspace/svg-workspace.component';
import { CutoutPoint } from '../../../../../models/cutting/cutting-panel-outline.model';
import { CuttingPanel } from '../../../../../models/cutting/cutting-panel.model';
import { Position } from '../../../../../models/cutting/cutting-svg.model';
import { PlateCutoutWizardDialogComponent } from '../plate-cutout-wizard-dialog/plate-cutout-wizard-dialog.component';

@Component({
  selector: 'csl-plate-cutout-list',
  templateUrl: './plate-cutout-list.component.html',
  styleUrls: ['./plate-cutout-list.component.scss'],
})
export class PlateCutoutListComponent {
  cutoutWizardDialogRef: MatDialogRef<PlateCutoutWizardDialogComponent>;
  dataSource: MatTableDataSource<Cutout> = new MatTableDataSource([]);
  displayedColumns = ['x', 'y', 'height', 'width', 'radius', 'panelBasePoint', 'cutoutBasePoint', 'slots', 'delete'];
  panelSnapshot: CuttingPanel;

  @Input() editable = true;
  @Input() set panel(val: CuttingPanel) {
    this.panelSnapshot = _.cloneDeep(val);

    const cos: Cutout[] = this.panelSnapshot.panelOutline.cutouts;

    this.dataSource.data = _.cloneDeep(cos);

    this.hideAndShowSlotsColumn();
  }

  @Input() groupId: number;

  @ViewChild('svgWorkspace', { static: true }) svgWorkspace: SvgWorkspaceComponent;

  @Output() formChanged: EventEmitter<Cutout[]> = new EventEmitter();

  thisCutoutPoint = CutoutPoint;

  constructor(public dialog: MatDialog) {}

  openWizard(): void {
    this.cutoutWizardDialogRef = this.dialog.open(PlateCutoutWizardDialogComponent, {
      disableClose: false,
      panelClass: 'cutout-wizard-dialog',
      minWidth: '1000px',
      width: '88vw',
      maxWidth: '88vw',
    });

    this.cutoutWizardDialogRef.componentInstance.panel = this.panelSnapshot;
    this.cutoutWizardDialogRef.componentInstance.groupId = this.groupId;

    this.cutoutWizardDialogRef.afterClosed().subscribe((result: Cutout) => {
      if (result) {
        const data = this.dataSource.data;

        data.push(result);

        this.dataSource.data = data;

        this.hideAndShowSlotsColumn();

        this.panelSnapshot.panelOutline.cutouts = data;

        this.formChanged.emit(data);
      }
      this.cutoutWizardDialogRef = null;
    });
  }

  deleteCutout(item: Cutout): void {
    const data = this.dataSource.data;

    const delIndex = data.findIndex(c => c === item);

    if (delIndex >= 0) {
      data.splice(delIndex, 1);
    }

    this.dataSource.data = data;

    this.hideAndShowSlotsColumn();

    this.formChanged.emit(data);
  }

  getCutoutName(item: Cutout): string {
    return item.name === undefined || item.name === '' ? $localize`Параметрический вырез` : item.name;
  }

  cutoutPoint2Position(cp: CutoutPoint): Position {
    switch (cp) {
      case CutoutPoint.TopLeft:
        return 'tl';
      case CutoutPoint.TopRight:
        return 'tr';
      case CutoutPoint.BottomLeft:
        return 'bl';
      case CutoutPoint.BottomRight:
        return 'br';
      case CutoutPoint.Center:
        return 'c';
    }
  }

  getSlotsDesignation(item: Cutout): string {
    if (item.slots?.length > 0) return item.slots.map(slot => slot.designation).join(', ');
  }

  hideAndShowSlotsColumn(): void {
    if (this.dataSource.data.findIndex((c: Cutout) => c.slots?.length > 0) === -1) {
      _.pull(this.displayedColumns, 'slots');
    } else if (!this.displayedColumns.includes('slots')) {
      this.displayedColumns.splice(this.displayedColumns.length - 1, 0, 'slots');
    }
  }
}
